export const serviceDetails = {
  hydraulics: {
    eyebrow: 'Hydraulic Repair',
    title: 'Hydraulic cylinder repair and rebuilding',
    intro:
      'Repair support for industrial hydraulic cylinders and systems used in production, handling, processing, and heavy-duty equipment across Canada.',
    image: '/images/landing-img1.png',
    primaryAction: 'Request Hydraulic Repair',
    capabilities: [
      'Hydraulic cylinder repair and rebuilding',
      'Rod, barrel, seal, and gland inspection',
      'Leak, drift, pressure loss, and scoring review',
      'Mounting point and component wear assessment',
      'Repair guidance from photos, nameplates, and equipment details',
      'Support for related hydraulic and mechanical components',
    ],
    warningSigns: [
      'External oil leaks or seal failure',
      'Cylinder drift under load',
      'Scored, bent, or damaged rods',
      'Loss of pressure or weak movement',
      'Noisy operation or inconsistent travel',
      'Worn pins, bushings, or mounting points',
    ],
    process: [
      'Send the equipment details, photos, dimensions, known symptoms, and location.',
      'We arrange pickup or shipping so the hydraulic component can be inspected in person.',
      'Once received, we review damage, wear, leakage, and repair feasibility before confirming the quote.',
      'After approval, we complete the repair or rebuild with practical checks before return.',
    ],
    faq: [
      {
        question: 'What hydraulic details help with a quote?',
        answer: 'Photos, cylinder dimensions, stroke length, rod diameter, mounting style, nameplate information, and a short description of the failure are all helpful.',
      },
      {
        question: 'Can a leaking cylinder be rebuilt?',
        answer: 'Often, yes. The right repair depends on rod condition, barrel condition, seal damage, and whether other parts are worn or damaged.',
      },
    ],
  },
  gearboxes: {
    eyebrow: 'Gearbox Repair',
    title: 'Industrial gearbox repair',
    intro:
      'Repair support for industrial gearboxes, reducers, drive components, and related mechanical systems used in demanding work environments.',
    image: '/images/landing-img2.png',
    primaryAction: 'Request Gearbox Repair',
    capabilities: [
      'Industrial gearbox inspection and repair support',
      'Bearing, seal, shaft, and gear damage review',
      'Oil leak, contamination, overheating, and vibration assessment',
      'Reducer and drive component repair guidance',
      'Support for worn or damaged mechanical assemblies',
      'Quote review based on photos, nameplates, symptoms, and operating details',
    ],
    warningSigns: [
      'Grinding, whining, clunking, or abnormal noise',
      'Excess heat during operation',
      'Oil leaks or visible contamination',
      'Metal particles in lubricant',
      'Vibration, misalignment, or unstable output',
      'Reduced torque, speed, or performance',
    ],
    process: [
      'Send photos, nameplate information, application details, symptoms, and location.',
      'We arrange pickup or shipping so the gearbox can be inspected in person.',
      'Once received, we review wear, failure points, and repair scope before confirming the quote.',
      'After approval, we repair or replace components as needed, then check the gearbox before return.',
    ],
    faq: [
      {
        question: 'What gearbox information should I send?',
        answer: 'Send the manufacturer, model, ratio if available, photos of the unit, photos of the nameplate, and any notes about noise, heat, leaks, or downtime.',
      },
      {
        question: 'When should a gearbox be inspected?',
        answer: 'A gearbox should be reviewed when it shows unusual noise, vibration, heat, leaks, contamination, or reduced output.',
      },
    ],
  },
  industrialRepair: {
    eyebrow: 'Industrial Repair',
    title: 'Industrial mechanical repair support',
    intro:
      'Repair support for industrial equipment with a practical focus on gearboxes, hydraulics, drive components, and related mechanical assemblies.',
    image: '/images/landing-img3.png',
    primaryAction: 'Request Industrial Repair',
    capabilities: [
      'Mechanical component inspection and repair support',
      'Gearbox and hydraulic-adjacent repair work',
      'Drive component and assembly review',
      'Wear, damage, alignment, and leakage assessment',
      'Repair planning for production and heavy-use equipment',
      'Canada-wide inquiry support for industrial customers',
    ],
    warningSigns: [
      'Unexpected downtime or repeated component failure',
      'Noise, vibration, or heat under load',
      'Leaks, visible wear, or damaged mounting points',
      'Reduced movement, speed, torque, or pressure',
      'Damaged shafts, housings, seals, or bearings',
      'Equipment that is costly or difficult to replace',
    ],
    process: [
      'Share photos, equipment information, operating context, failure symptoms, and location.',
      'We arrange pickup or shipping so the equipment can be inspected in person.',
      'Once received, we review the repair need against gearbox, hydraulic, and mechanical repair options.',
      'After approval, we complete the repair with attention to fit, function, and return-to-service needs.',
    ],
    faq: [
      {
        question: 'What counts as industrial repair?',
        answer: 'For us, industrial repair means practical repair support for gearboxes, hydraulics, drive components, and related mechanical equipment.',
      },
      {
        question: 'Can I send photos before bringing equipment in?',
        answer: 'Yes. Photos, nameplates, dimensions, and symptom notes are useful for an initial review and quote conversation.',
      },
    ],
  },
};
